<script lang="ts">
  import { botInfo } from "./store";
  import { type QuickReply } from "./service/service";
  import { createEventDispatcher } from "svelte";

  export let quickReplies: QuickReply[] = [];

  const dispatch = createEventDispatcher();
</script>

<div class="chat-quick-reply-container">
  {#each quickReplies as qrs, i}
    <button
      style="border-color: {$botInfo?.settings?.widgetBackgroundColor || '#0e3c26'}"
      on:click={() => dispatch("sendQr", { data: qrs })}
    >
      <span style="color: {$botInfo?.settings?.widgetBackgroundColor || '#0e3c26'}"
        >{qrs.title}</span
      >
    </button>
  {/each}
</div>

<style>
  .chat-quick-reply-container {
    /* width: 350px; */
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 5px;
    margin: 10px;
  }
  .chat-quick-reply-container > button {
    background-color: #fff;
    border-radius: 8px;
    border-width: 1px;
    border-style: solid;
    cursor: pointer;
    padding: 3px 10px;
    height: 30px;
  }
  .chat-quick-reply-container > button > span {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial,
      "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
      "Noto Color Emoji";
    font-size: 12px;
    line-height: 20px;
  }
</style>
